export default "__VITE_ASSET__$eEamQ_F__"